// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","menuTooltip":"SlashMenu_menuTooltip__2UfUu","visible":"SlashMenu_visible__3Mb5-"};